import ExportedImage from 'next-image-export-optimizer';
import styles from './index.module.scss';

type Props = {
  href: string;
  title: string;
  description?: string;
  thumbnailUrl?: string;
  target?: '_blank' | '_self';
};

/** next-image-export-optimizer はビルド時にローカル画像しか最適化できないため、外部 URL は最適化を通さない */
const isExternalUrl = (url: string) => /^https?:\/\//.test(url);

const LinkCard = ({ href, title, description, thumbnailUrl, target = '_self' }: Props) => (
  <a href={href} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined} className={styles.base}>
    {thumbnailUrl && isExternalUrl(thumbnailUrl) ? (
      // eslint-disable-next-line @next/next/no-img-element
      <img src={thumbnailUrl} alt={title} className={styles.thumbnail} width={400} height={300} loading="lazy" />
    ) : null}
    {thumbnailUrl && !isExternalUrl(thumbnailUrl) ? (
      <ExportedImage
        src={thumbnailUrl}
        alt={title}
        className={styles.thumbnail}
        width={400}
        height={300}
        loading="lazy"
      />
    ) : null}
    <h3 className={styles.title}>{title}</h3>
    {description ? <p className={styles.description}>{description}</p> : null}
  </a>
);

export default LinkCard;
